export default "__VITE_ASSET__CcuRmYAc__"